import { cn } from '@/lib/cn';

interface Props {
  className?: string;
  variant?: 'light' | 'dark';
}

/**
 * Plan §17.8 — „powered by BIK" als hairline-Footer-Zeile.
 * Niemals als Button, kein Hover-Effekt, kleines „p".
 */
export function PoweredByBIK({ className, variant = 'light' }: Props) {
  return (
    <p
      className={cn(
        'select-none text-[10px] font-normal tracking-wide',
        variant === 'light' ? 'text-ink-400' : 'text-ink-500',
        className,
      )}
    >
      powered by BIK
    </p>
  );
}
